import config from './config';

function cutString(string, limit) {
  if (string.length > limit) {
    string = `${string.substr(0, limit - 3)}...`;
  }
  return string;
}

function getFileNameFromLink(link) {
  const query = link.split('?')[1];
  if (query) {
    return query.split('=')[1];
  }
  return '';
}

const extensionMapping = config.files.extensionMapping;

function getFileTypeFromLink(link) {
  const fileName = getFileNameFromLink(link);
  return getFileTypeFromName(fileName);
}

function getFileTypeFromName(fileName) {
  const a = fileName.split('.');
  if (a.length === 1 || (a[0] === '' && a.length === 2)) {
    return 'file';
  }
  let type = 'file';
  const extension = a.pop();
  for (const fileType in extensionMapping) {
    if (extensionMapping.hasOwnProperty(fileType) && extensionMapping[fileType].includes(extension)) {
      type = fileType;
      break;
    }
  }
  return type;
}

function isFileTypeInList(type, linkList) {
  for (const link of linkList) {
    const fileType = getFileTypeFromLink(link);
    if (fileType === type) {
      return true;
    }
  }
  return false;
}

export {
  cutString, getFileNameFromLink, getFileTypeFromName, getFileTypeFromLink, isFileTypeInList,
};



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/util.js